<template>
    <b-row>
        <b-col cols="12">
            <b-form-group label="Questionnaire">
                <b-form-textarea v-model="currentContentSection.titre" required />
            </b-form-group>
        </b-col>
        <b-col cols="6">
            <b-form-group label="Type de réponse">
                <v-select v-model="currentContentSection.champsModel" :options="champsEnumOptions" required />
            </b-form-group>
        </b-col>

        <b-col cols="6">
            <b-form-group label="Info-Bulle">
                <b-form-input v-model="currentContentSection.description" />
            </b-form-group>
        </b-col>
        <b-col cols="6">
            <b-form-group label="Taille de composant (Min 1 - Max 12)">
                <numeric-input id="demo-sb" v-model="currentContentSection.taille" :min="0" :max="12" :step="1" />
            </b-form-group>
        </b-col>
        <b-col cols="6">
            <b-form-group label="Incrementation maximale">
                <numeric-input id="demo" v-model="currentContentSection.max" :min="0" :max="100" :step="1" />
            </b-form-group>
        </b-col>
        <b-col cols="4">
            <b-form-group label="Composant Obligatoire">
                <b-form-checkbox v-model="currentContentSection.required" switch inline>
                    Obligatoire
                </b-form-checkbox>
            </b-form-group>
        </b-col>

        <b-col cols="4">
            <b-form-group label="Lecture seule">
                <b-form-checkbox v-model="currentContentSection.readonly" switch inline :true-value="'readonly'"
                    :false-value="null">
                    Lecture seule
                </b-form-checkbox>
            </b-form-group>
        </b-col>
        <b-col cols="4">
            <b-form-group label="Somme">
                <b-form-checkbox v-model="currentContentSection.somme" switch inline>
                    Somme
                </b-form-checkbox>
            </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Afficher la réponse dans le récapitulatif ?">
            <b-form-checkbox v-model="currentContentSection.reponse" switch inline>
              Réponse
            </b-form-checkbox>
          </b-form-group>
        </b-col>



        <div v-if="isListeType(currentContentSection.champsModel)">
            <hr />
            <label for="tags-basic">Tapez une nouvelle valeur et appuyez sur Entrée</label>

            <b-form-tags v-model="currentContentSection.valueList" no-outer-focus>

                <template v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                    <b-input-group aria-controls="my-custom-tags-list">
                        <input v-bind="inputAttrs" placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                            class="form-control" v-on="inputHandlers" />
                        <b-input-group-append>
                            <b-button variant="primary" @click="addTag()">Ajouter</b-button>
                        </b-input-group-append>
                    </b-input-group>
                    <ul id="my-custom-tags-list" class="list-unstyled d-inline-flex flex-wrap mb-0">
                        <b-card v-for="tag in tags" :key="tag" tag="li" class="shadow-none border mt-1 mr-1 mb-0">
                            <strong>{{ tag }}</strong>
                            <b-button variant="link" size="sm" @click="removeTag(tag)" class="py-0">
                                Supprimer
                            </b-button>
                        </b-card>
                    </ul>
                </template>
            </b-form-tags>


        </div>
        <hr />

        <b-col cols="12">
            <div class="d-flex justify-content-end">
                <b-button variant="outline-primary" @click="createComponent">
                    <feather-icon icon="EyeIcon" class="mr-50" />
                    <span class="align-middle">Voir</span>
                </b-button>
            </div>
        </b-col>

        <b-card-body>
            <div ref="form" class="repeater-form">
                <b-row ref="row" class="px-2">
                    <b-col v-for="(component, index) in componentsList" :key="component.titre" :cols="component.taille"
                        :xl="component.taille">
                        <div class="d-flex border rounded">
                            <b-row class="flex-grow-1 p-2">
                                <b-col>
                                    <b-form-group :label="component.titre">

                                        <component v-if="component.type !== 'liste'"
                                            :is="resolveComponent(component.value)" :title="component.titre"
                                            description="component.description"
                                            v-b-tooltip.hover.v-primary="component.description" v-bind="{
                                                switch: component.autres === 'switch',
                                                inline: component.autre === 'inline'
                                            }" :required="component.required && component.type !== 'liste'"/>

                                        <component v-else-if="component.type === 'liste'"
                                            :is="resolveComponent(component.value)" :title="component.titre"
                                            :description="component.description"
                                            v-b-tooltip.hover.v-primary="component.description" v-bind="{
                                                multiple: component.autre === 'multiple',
                                                switch: component.autre === 'switch',
                                                inline: component.autre === 'inline'
                                            }" :required="component.required && component.type === 'liste'"
                                            :options="component.valueList" />

                                        <div v-else-if="component.label === 'Tags'">
                                            <b-form-tags v-model="value" no-outer-focus>
                                                <template
                                                    v-slot:default="{ tags, inputAttrs, inputHandlers, addTag, removeTag }">
                                                    <b-input-group aria-controls="my-custom-tags-list">
                                                        <input v-bind="inputAttrs"
                                                            placeholder="Nouvelle balise - Appuyez sur Entrée pour ajouter"
                                                            class="form-control" v-on="inputHandlers">
                                                        <b-input-group-append>
                                                            <b-button variant="primary" @click="addTag()">
                                                                Ajouter
                                                            </b-button>
                                                        </b-input-group-append>
                                                    </b-input-group>
                                                    <ul id="my-custom-tags-list"
                                                        class="list-unstyled d-inline-flex flex-wrap mb-0"
                                                        aria-live="polite" aria-atomic="false"
                                                        aria-relevant="additions removals">

                                                        <b-card v-for="tag in tags"
                                                            :id="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                                                            :key="tag" tag="li"
                                                            class="shadow-none border mt-1 mr-1 mb-0"
                                                            body-class="py-1 pr-2 text-nowrap">
                                                            <strong>{{ tag }}</strong>
                                                            <b-button variant="link" size="sm"
                                                                :aria-controls="`my-custom-tags-tag_${tag.replace(/\s/g, '_')}_`"
                                                                class="py-0" @click="removeTag(tag)">
                                                                Supprimer
                                                            </b-button>
                                                        </b-card>
                                                    </ul>
                                                </template>
                                            </b-form-tags>
                                        </div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <div class="d-flex flex-column justify-content-between border-left py-50 px-25">
                                <feather-icon size="16" icon="XIcon" class="cursor-pointer"
                                    @click="removeItem(index)" />
                            </div>
                        </div>

                    </b-col>

                </b-row>
            </div>
        </b-card-body>

        <b-col cols="12" v-if=currentContentSection.somme>

            <hr />
            <b-card-body class="invoice-padding pb-0">
                <b-row>
                    <b-col cols="12" xl="12">
                        <b-form-group label="Section">
                            <v-select :options="sections" :reduce="section => section.idPublic" label="title"
                                v-model="selectedSectionId" required>
                            </v-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" xl="12" v-if="!isStandardSection">
                        <b-form-group label="Liste des modules">
                            <v-select label="titre" :options="contentSection"
                                v-model="selectedcomponentsModalSommeList" />
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" xl="12" v-if="!isStandardSection">
                        <b-form-group label="Liste de question">
                            <v-select v-model="sommeContent.componentModel" multiple label="titre"
                                :options="selectedcomponentsModalSommeList.componentModels" />
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" xl="12">
                        <b-form-group label="La réponse a sommé">
                            <v-select v-model="sommeContent.contentSection" label="titre"
                                :options="selectedcomponentsModalSommeList.contentSections"
                                @input="setSommeContentId(currentContentSection)" />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-col>
    </b-row>
</template>

<script>
import {
    BRow, BCol, BFormGroup, BFormTextarea, BFormInput,
    // BFormSpinbutton,
  BFormCheckbox, BFormTags, BInputGroup,
    BInputGroupAppend, BButton, BCard, BCardBody
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import { allSectionContent } from '@/services/ContentSectionService';
import NumericInput from "@/util/NumericInput.vue";
export default {
    components: {
      NumericInput,
        BRow,
        BCol,
        BFormGroup,
        BFormTextarea,
        vSelect,
        BFormInput,
        // BFormSpinbutton,
        BFormCheckbox,
        BFormTags,
        BInputGroup,
        BInputGroupAppend,
        BButton,
        BCard
    },
    data() {
        return {
            componentsList: [],
            selectedSectionId: null,
            selectedcomponentsModalSommeList: {
                titre: '',
                contentSections: [],
                componentModels: []
            },
            contentSection: [],
            componentModelSectionList: [],
            componentsModalSommeList: [],
            sommeContent: {
                contentSection: {
                    titre:null
                },
                componentModel: []
            },
            localContentSection: { ...this.currentContentSection },

        }
    },
    props: {
        currentContentSection: {
            type: Object,
            required: true,
            default: () => ({}),
        },
        champsEnumOptions: {
            type: Array,
            required: true,
            default: () => [],
        },

        sections: {
            type: Array,
            required: true,
            default: () => [],
        },

    },
    computed: {
        isStandardSection() {
            const selectedSection = this.sections.find(section => section.idPublic === this.selectedSectionId);
            return selectedSection && selectedSection.type === 'standard';
        },
    },
    methods: {
        setSommeContentId(section) {
            this.sommeContent.idPublic = section.idPublic;
        },
        createComponent() {
            this.resetComponentsList();
            const componentToAdd = {
                ...this.currentContentSection,
                // champs: this.champsEnumOptions.find(option => option.value === this.currentContentSection.champsModel.value),
                value: this.currentContentSection.champsModel.value,
                type: this.currentContentSection.champsModel.type,
                label: this.currentContentSection.champsModel.label
            };
            if (!componentToAdd.value) {
                console.error('componentToAdd.value is undefined');
                return;
            }

            this.componentsList.push(componentToAdd);
            this.isModalActive = true;
        },
        resetComponentsList() {
            this.componentsList = [];
        },
        removeItem(index) {
            this.componentsList.splice(index, 1);
        },
        resolveComponent(componentValue) {
            return componentValue || 'b-form-textarea';
        },
        updateContentSection() {
            this.currentContentSection = {
            ...this.currentContentSection, // Conserver les propriétés existantes
            sommeContent: this.sommeContent // Ajouter ou mettre à jour sommeContent
        };
            this.$emit('update:currentContentSection', this.localContentSection);
        },

        async updateContentAndComponentModels(sectionId) {
            try {
                this.contentSection = await allSectionContent(sectionId);
                // this.componentsModalSommeList = this.contentSection;

            } catch (error) {
                console.error("Erreur lors de la mise à jour des champs :", error);
            }
        },

        isListeType(champsModel) {
            return champsModel?.type === "liste";
        },
    },
    watch: {
        currentContentSection: {
            handler: function (newVal) {
                this.localContentSection = { ...newVal };
            },
            deep: true,
        },


        selectedSectionId: {
            handler: function (newVal) {
                if (newVal) {
                    this.updateContentAndComponentModels(newVal);

                }
            }
        },

    },
}
</script>

<style></style>
